<template>
    <router-link
        :to="to"
        :disabled="disabled"
        tag="button"
        class="w-full p-4 rounded text-center font-bold tracking-wide uppercase focus:outline-none focus:shadow-outline"
        :class="[ secondary ? 'bg-highlight-20' : 'bg-primary text-highlight-100' ]"
    >
        <slot/>
    </router-link>
</template>

<script>
export default {
    props: {
        to: {
            type: [String, Object],
            required: true,
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        secondary: {
            type: Boolean,
            default: false,
        },
    },
}
</script>
